import { useEffect, useState } from 'react'
import org_api from '../api/admin/admin_orgs'
import org_admin_api from '../api/orgadmin/orgadmin_orgs'
import customer_api from '../api/customer/customer_orgs'
import profapi from "../api/profile";
import AdminNewOrganisation from '../components/AdminNewOrganisation'
import AdminOrganisationGrid from '../components/AdminOrganisationGrid'
import AdminReportOverviewGrid from '../components/AdminReportOverviewGrid'
import MainHeader from '../components/MainHeader'
import RICSValuationHub from '../components/rics_hub/RICSValuationHub'
import { defaultRange } from '../components/finviseMetrics'
import roles from '../models/Roles'
import FinviseDashboard from './FinviseDashboard'
import FinviseProperties from './FinviseProperties'

const AdminOrganisations = () => {
	const [showNewOrg, setShowNewOrg] = useState(false)
	const [showOverview, setShowOverview] = useState(false)
	const [showOrganisations, setShowOrganisations] = useState(true)
	const [showRICSHub, setShowRICSHub] = useState(false)
	const [profile, setProfile] = useState()
	const [organisations, setOrganisations] = useState()
	const [showDashboard, setShowDashboard] = useState(false)
	const [showProperties, setShowProperties] = useState(false)
	// shared between FinviseDashboard and FinviseProperties so picking a
	// period on one carries over to the other
	const [finviseRange, setFinviseRange] = useState(defaultRange)
	const [finviseOrgFilter, setFinviseOrgFilter] = useState([])
	const updateNewOrg = show => {
		getOrgs()
		setShowNewOrg(show)
		setShowOrganisations(!show)
	}

	const updateShowOrg = show => {
		setShowNewOrg(show)
		setShowOrganisations(!show)
	}

	const updateProfile = profile => {
		setProfile(profile)
	}

  const getProfile = () => {
    let response = profapi.getProfile();
    response.then(
      response => {
        setProfile(response.data);
      }
    ).catch(err => {
      console.log(err);
    })
  }

	const getOrgs = () => {
		if (!profile) return

		// let response = org_api.getOrganisations()
		let response = null
		if (profile.role_id === roles.ROLE_ADMIN) {
			// Pass the id through to the api call for full admin
			response = org_api.getOrganisations()
		} else if (profile.role_id === roles.ROLE_ORGANISATION_ADMIN) {
			// Let the api determine the org id based on the org admin logged in
			response = org_admin_api.getOrganisation()
		} else {
			response = customer_api.getOrganisation()
    }
		response.then(response => {
			setOrganisations(response.data.organisations)
		})
	}

	useEffect(() => {
    if (!profile) {
      getProfile()
    }
	}, [])

	useEffect(() => {
		getOrgs()
	}, [profile])

	useEffect(() => {
		// Don't let a non admin navigate here by hand
		if (!profile) return
		if (profile && profile.role_id === roles.ROLE_ADMIN)
			handleShowOrganisationsClick()
		else if (
			profile &&
			(profile.role_id === roles.ROLE_USER ||
				profile.role_id === roles.ROLE_ORGANISATION_ADMIN)
		)
			handleOverviewClick()
		else window.location.assign('/')
	}, [profile])

	function handleOverviewClick() {
		setShowNewOrg(false)
		setShowOrganisations(false)
		setShowOverview(true)
		setShowRICSHub(false)
		setShowDashboard(false)
		setShowProperties(false)
	}

	function handleShowOrganisationsClick() {
		setShowOverview(false)
		setShowNewOrg(false)
		setShowOrganisations(true)
		setShowRICSHub(false)
		setShowDashboard(false)
		setShowProperties(false)
	}

	function handleShowRICSHubClick() {
		setShowOverview(false)
		setShowNewOrg(false)
		setShowOrganisations(false)
		setShowRICSHub(true)
		setShowDashboard(false)
		setShowProperties(false)
	}
	function handleDashboardClick() {
		setShowNewOrg(false)
		setShowOrganisations(false)
		setShowOverview(false)
		setShowRICSHub(false)
		setShowProperties(false)
		setShowDashboard(true)
	}
	function handlePropertiesClick() {
		setShowNewOrg(false)
		setShowOrganisations(false)
		setShowOverview(false)
		setShowRICSHub(false)
		setShowDashboard(false)
		setShowProperties(true)
	}
	console.log(showDashboard, 'showDashboard', showProperties, 'showProperties')
	return (
		<>
			<MainHeader updateProfile={updateProfile.bind(this)} />
			<div className='admin-organisation-page-container'>
				<div className='admin-organisation-container'>
					<div className='admin-organisation-sidemenu col'>
						{profile && profile.role_id === roles.ROLE_ADMIN ? (
							<>
								<div className='admin-organisation-menu-title'>FINVISE</div>
								<div className='admin-organisation-menu-subtitle'>
									Admin view
								</div>
							</>
						) : null}

						{profile &&
						(profile.role_id === roles.ROLE_USER ||
							profile.role_id === roles.ROLE_ORGANISATION_ADMIN ||
							profile.role_id === roles.ROLE_ADMIN) ? (
							<div
								className={
									showOverview
										? 'admin-organisation-category-title link active'
										: 'admin-organisation-category-title link'
								}
								onClick={handleOverviewClick}
								style={{ display: 'none' }}
							>
								Overview
							</div>
						) : null}
						{profile && profile.role_id === roles.ROLE_ADMIN ? (
							<>
								<div
									className={
										showOrganisations
											? 'admin-organisation-category-title link active'
											: 'admin-organisation-category-title link'
									}
									onClick={handleShowOrganisationsClick}
								>
									Organisations
								</div>
								<div
									className={
										showRICSHub
											? 'admin-organisation-category-title link active'
											: 'admin-organisation-category-title link'
									}
									onClick={handleShowRICSHubClick}
								>
									RICS Valuation Hub
								</div>
						    <div
						    	className={
						    		showDashboard
						    			? 'admin-organisation-category-title link active'
						    			: 'admin-organisation-category-title link'
						    	}
						    	onClick={handleDashboardClick}
						    >
						    	Dashboard
						    	<span className='admin-organisation-nav-badge'>New</span>
						    </div>

						    <div
						    	className={
						    		showProperties
						    			? 'admin-organisation-category-title link active'
						    			: 'admin-organisation-category-title link'
						    	}
						    	onClick={handlePropertiesClick}
						    >
						    	Report Register
						    	<span className='admin-organisation-nav-badge'>New</span>
						    </div>
							</>
						) : null}
					</div>

					<div className='admin-organisation-content col'>
						{showNewOrg ? (
							<>
								<AdminNewOrganisation update={updateNewOrg.bind(this)} />
							</>
						) : null}
						{showOrganisations ? (
							<>
								<div className='admin-organisation-content-title'>
									Organisations
								</div>
								<AdminOrganisationGrid
									update={updateShowOrg.bind(this)}
									organisations={organisations}
								/>
							</>
						) : null}
						{showOverview ? (
							<>
								<AdminReportOverviewGrid profile={profile} />
							</>
						) : null}
						{showRICSHub ? (
							<>
								<RICSValuationHub />
							</>
						) : null}
						{showDashboard ? (
							<FinviseDashboard
								range={finviseRange}
								onRangeChange={setFinviseRange}
								orgFilter={finviseOrgFilter}
								onOrgFilterChange={setFinviseOrgFilter}
							/>
						) : null}
						{showProperties ? (
							<FinviseProperties
								range={finviseRange}
								onRangeChange={setFinviseRange}
								orgFilter={finviseOrgFilter}
								onOrgFilterChange={setFinviseOrgFilter}
							/>
						) : null}
					</div>
				</div>
			</div>
		</>
	)
}

export default AdminOrganisations
